module.exports = __webpack_public_path__ + "img/sucai-3.b010ad43.jpg";